import React from "react";
import { Route } from "react-router-dom";
import MainLayout from "../layout/MainLayout";
import Exercises from "../pages/Exercises/Exercises";
import PlanTemplate from "../pages/PlanTemplate/PlanTemplate";
import PlanTemplates from "../pages/PlanTemplates/PlanTemplates";
import Workouts from "../pages/Workouts/Workouts";

export const MY_LIBRARY_ROUTES = {
  PLAN_TEMPLATES: "/my-library/plan-templates",
  PLAN_TEMPLATE: "/my-library/plan-templates/:id",
  EXERCISES: "/my-library/exercises",
  WORKOUTS: "/my-library/workouts",
};

const MyLibraryRoutes = () => {
  return (
    <>
      <Route path={MY_LIBRARY_ROUTES.PLAN_TEMPLATE}>
        <MainLayout>
          <PlanTemplate />
        </MainLayout>
      </Route>
      <Route path={MY_LIBRARY_ROUTES.PLAN_TEMPLATES} exact>
        <MainLayout>
          <PlanTemplates />
        </MainLayout>
      </Route>
      <Route path={MY_LIBRARY_ROUTES.EXERCISES}>
        <MainLayout>
          <Exercises />
        </MainLayout>
      </Route>
      <Route path={MY_LIBRARY_ROUTES.WORKOUTS}>
        <MainLayout>
          <Workouts />
        </MainLayout>
      </Route>
    </>
  );
};

export default MyLibraryRoutes;
